import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/TelegramLinkModal.css';

const TelegramLinkModal = ({ onClose }) => {
    const { showNotification } = useAuth();
    const [telegramLinkStatus, setTelegramLinkStatus] = useState({
        isLinked: false,
        telegramUsername: null
    });
    const [loading, setLoading] = useState(false);

    // Определяем имя бота на основе конфига
    const getBotUsername = () => {
        if (window.config && window.config.API_URL) {
            const apiUrl = window.config.API_URL;
            if (apiUrl.includes('oncaspin')) {
                return 'oncaspin_bot';
            } else {
                return 'Staging728356_bot';
            }
        }
        return 'oncaspin_bot'; // fallback
    };

    useEffect(() => {
        fetchTelegramLinkStatus();
        // Автообновление статуса каждые 3 секунды для отслеживания привязки
        const interval = setInterval(fetchTelegramLinkStatus, 3000);
        return () => clearInterval(interval);
    }, []);

    const fetchTelegramLinkStatus = async () => {
        try {
            const response = await fetch('/api/telegram/link-status', {
                credentials: 'include'
            });
            const data = await response.json();
            if (data.success) {
                setTelegramLinkStatus({
                    isLinked: data.isLinked,
                    telegramUsername: data.telegramUsername
                });
            }
        } catch (error) {
            console.error('Ошибка получения статуса привязки Telegram:', error);
        }
    };

    const handleTelegramUnlink = async () => {
        if (!window.confirm('Вы уверены, что хотите отвязать Telegram аккаунт?')) {
            return;
        }

        setLoading(true);
        try {
            const response = await fetch('/api/telegram/unlink', {
                method: 'POST',
                credentials: 'include'
            });
            const data = await response.json();

            if (data.success) {
                showNotification(data.message, 'success');
                setTelegramLinkStatus({ isLinked: false, telegramUsername: null });
            } else {
                showNotification(data.message || 'Ошибка при отвязке Telegram', 'error');
            }
        } catch (error) {
            console.error('Ошибка отвязки Telegram:', error);
            showNotification('Произошла ошибка при отвязке Telegram', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="telegram-modal-overlay" onClick={(e) => {
            if (e.target === e.currentTarget) {
                onClose();
            }
        }}>
            <div className="telegram-modal" onClick={(e) => e.stopPropagation()}>
                <button className="telegram-modal-close" onClick={onClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="12" fill="#23232e" />
                        <path d="M16 8L8 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                        <path d="M8 8L16 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>

                <h3 className="telegram-modal-title">📱 Привязка Telegram</h3>

                <div className="telegram-modal-form">
                    {telegramLinkStatus.isLinked ? (
                        // Уже привязан
                        <div>
                            <div className="telegram-status-card linked">
                                <div className="telegram-status-icon">✅</div>
                                <h4 className="telegram-status-title linked">
                                    Telegram успешно привязан
                                </h4>
                                <p className="telegram-status-description linked">
                                    {telegramLinkStatus.telegramUsername
                                        ? `@${telegramLinkStatus.telegramUsername}`
                                        : 'Ваш аккаунт связан с Telegram'
                                    }
                                </p>
                            </div>

                            <div className="telegram-field">
                                <span className="telegram-field-label">Доступные возможности</span>
                                <div className="telegram-benefits-box">
                                    <div className="telegram-benefits-text">
                                        📨 Уведомления о депозитах и выводах<br />
                                        🎁 Эксклюзивные бонусы через бота<br />
                                        ⚡ Быстрая поддержка через Telegram
                                    </div>
                                </div>
                            </div>

                            <div className="telegram-action-section">
                                <button
                                    type="button"
                                    className="telegram-btn telegram-btn-danger"
                                    onClick={handleTelegramUnlink}
                                    disabled={loading}
                                >
                                    {loading ? 'Отвязывание...' : 'Отвязать Telegram'}
                                </button>
                            </div>
                        </div>
                    ) : (
                        // Не привязан
                        <div>
                            <div className="telegram-status-card not-linked">
                                <div className="telegram-status-icon">📱</div>
                                <h4 className="telegram-status-title not-linked">
                                    Привяжите Telegram аккаунт
                                </h4>
                                <p className="telegram-status-description not-linked">
                                    Получите <strong>50 фриспинов</strong> за привязку!
                                </p>
                            </div>

                            <div className="telegram-field">
                                <span className="telegram-field-label">Инструкция по привязке</span>
                                <div className="telegram-instructions-box">
                                    <ol className="telegram-instructions-list">
                                        <li>Откройте нашего бота <strong className="telegram-highlight-blue">@{getBotUsername()}</strong></li>
                                        <li>Нажмите кнопку <strong className="telegram-highlight-blue">"🔗 Привязать аккаунт"</strong></li>
                                        <li>Перейдите по ссылке из бота</li>
                                        <li>Получите <strong className="telegram-highlight-yellow">50 фриспинов!</strong> 🎁</li>
                                    </ol>
                                </div>
                            </div>

                            <div className="telegram-action-section">
                                <a
                                    href={`https://t.me/${getBotUsername()}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="telegram-btn telegram-btn-primary"
                                >
                                    📱 Открыть Telegram бота
                                </a>
                                <p className="telegram-note">
                                    После привязки это окно автоматически обновится
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TelegramLinkModal;
